import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';

@JsonObject('model.ShortOrderItem')
export class ShortOrderItem extends AbstractModel {
    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(Boolean, 'ready')
    ready?: boolean;
}

